let PlayerSettingPopup = {
    PLAYER_SETTING_POPUP_SET_STATE: 'PLAYER_SETTING_POPUP_SET_STATE',
};

export default PlayerSettingPopup;
